module.exports = __webpack_public_path__ + "static/hexa_inovation-2cb2ad916a905b3ad4b20db9be0e12e1.svg";